// Central brand + contact configuration for NGM Nordglanz Mobilitätsservice
export const BRAND = {
  name: "NGM Nordglanz",
  full: "NGM Nordglanz Mobilitätsservice",
  tagline: "ZUVERLÄSSIG. SAUBER. EINSATZBEREIT.",
  // Placeholder contact details — replace with real data when available.
  email: "support@ngm-service.de",
  phone: "+49 178 4630624",
  // Digits only for wa.me deep link.
  whatsapp: "491784630624",
};

export const whatsappLink = () => `https://wa.me/${BRAND.whatsapp}`;

export const IMAGES = {
  // Black car side sprayed with water, subtle rainbow — neutral, no brand logo.
  hero: "https://images.pexels.com/photos/4870671/pexels-photo-4870671.jpeg",
  cleaning: "https://images.pexels.com/photos/6872146/pexels-photo-6872146.jpeg",
  // Chauffeur (back view) opening a luxury car door — no faces, no brand logo.
  chauffeur: "https://images.pexels.com/photos/7594130/pexels-photo-7594130.jpeg",
  texture: "https://images.pexels.com/photos/37955290/pexels-photo-37955290.jpeg",
  transfer: "https://images.pexels.com/photos/35999590/pexels-photo-35999590.jpeg",
};
